import i18n from "intl/i18n"
import { Guid } from "@/types"
import { formatNumber } from "utils/utils"
import AssetArticle from "./AssetArticle"
import Unit from "./Unit"

export interface IGetShippingOrderCartManualPositionDto {
    id: Guid
    assetId?: Guid | null
    transportId?: Guid | null
    description: string
    measurementSystemId: Guid
    dimension1?: number | null
    dimension2?: number | null
    dimension3?: number | null
    weight?: number | null
    departureLocationId: Guid
    arrivalLocationId: Guid
}

export interface ICreateShippingOrderCartManualPositionDto {
    assetId?: Guid | null
    description: string
    measurementSystemId: Guid
    dimension1?: number | null
    dimension2?: number | null
    dimension3?: number | null
    weight?: number | null
    departureLocationId: Guid
    arrivalLocationId: Guid
}

export interface IUpdateShippingOrderCartManualPositionDto {
    ids: Guid[]
    transportId?: Guid | null
    transportSequence?: number | null
    description?: string
    measurementSystemId?: Guid
    dimension1?: number | null
    dimension2?: number | null
    dimension3?: number | null
    weight?: number | null
}

export default class ShippingOrderCartManualPosition {
    id: Guid
    assetId?: Guid
    transportId?: Guid
    description: string
    measurementSystemId: Guid
    dimension1?: number
    dimension2?: number
    dimension3?: number
    weight?: number
    departureLocationId: Guid
    arrivalLocationId: Guid
    sequence?: number

    asset?: AssetArticle

    constructor(data: IGetShippingOrderCartManualPositionDto, sequence?: number) {
        this.id = data.id
        this.assetId = data.assetId ?? undefined
        this.transportId = data.transportId ?? undefined
        this.description = data.description
        this.measurementSystemId = data.measurementSystemId
        this.dimension1 = data.dimension1 ?? undefined
        this.dimension2 = data.dimension2 ?? undefined
        this.dimension3 = data.dimension3 ?? undefined
        this.weight = data.weight ?? undefined
        this.departureLocationId = data.departureLocationId
        this.arrivalLocationId = data.arrivalLocationId
        this.sequence = sequence
    }

    get isInTransport() {
        return !!this.transportId
    }

    printWeight() {
        return typeof this.weight === "number" ? `${formatNumber(this.weight)} ${i18n.t("common.kg")}` : ""
    }

    printDimensions(unit: Unit | null) {
        const unitLabel = unit?.printShort() || ""
        const dimensions = [
            typeof this.dimension1 === "number" ? `${i18n.t('common.dimensionShort.length')} ${formatNumber(this.dimension1)} ${unitLabel}` : null,
            typeof this.dimension2 === "number" ? `${i18n.t('common.dimensionShort.width')} ${formatNumber(this.dimension2)} ${unitLabel}` : null,
            typeof this.dimension3 === "number" ? `${i18n.t('common.dimensionShort.height')} ${formatNumber(this.dimension3)} ${unitLabel}` : null,
        ].filter(d => !!d)

        if (dimensions.length === 0) return ""
        return dimensions.join(" x ")
    }
}
